<div fxLayout="row" fxLayoutAlign="start center" class="step">
    @for (step of steps; track step; let first = $first; let last = $last; let index = $index) {
        <div fxLayout="row" fxLayoutAlign="start center"
             [class.ml-16]="!first"
             [class.pointer]="isStepClickable(index)"
             (click)="goToStep(index)">
            @if (index === currentStepIndex || index > maxVisitedStepIndex) {
                <div class="circle i-24 index t4"
                     [class.disabled]="index > maxVisitedStepIndex"
                     fxLayoutAlign="center center">{{ index + 1 }}
                </div>
            }
            @if (index !== currentStepIndex && index <= maxVisitedStepIndex && isStepDone(index)) {
                <div class="circle i-24 completed" fxLayoutAlign="center center">
                    <ui-kit-svg class="i-16" name="ic_checkmark_small"/>
                </div>
            }
            @if (index !== currentStepIndex && index <= maxVisitedStepIndex && !isStepDone(index)) {
                <div class="circle i-24 index t4" fxLayoutAlign="center center">{{ index + 1 }}</div>
            }
            <div class="ml-8 t2"
                 [class.c-primary-gray-900]="index <= maxVisitedStepIndex"
                 [class.c-primary-gray-400]="index > maxVisitedStepIndex">{{ 'i18n_lib_stepperLabel_' + step | translate }}</div>
        </div>
        @if (!last) {
            <div class="line"></div>
        }
    }
</div>
